<template>
  <div class="struk-section">
    <div class="card-holder d-flex align-center">
      <v-card class="card py-5">
        <div class="card-title d-flex justify-center">
          <h2>Struk Pembayaran</h2>
        </div>
        <div class="card-body py-5">
          <div class="preview-holder">
            <div class="preview d-flex justify-center align-center">
              <img
                class="preview-image"
                :src="`https://dev-api-ppdb.smkruskudus.com/storage/${lmp_pembayaran.lmp_image}`"
                alt="image"
              />
            </div>
          </div>
        </div>

        <div class="actions d-flex justify-center ma-5">
          <v-btn color="error" class="ma-5" @click="actionForm('REJECT')"
            >Tolak</v-btn
          >
          <v-btn color="primary" class="ma-5" @click="actionForm('ACCEPT')"
            >Terima</v-btn
          >
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../event-bus";
import axios from "axios";

export default {
  data: () => ({
    id: "",
    lmp_pembayaran: "",
  }),
  mounted() {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          localStorage.clear();
          let hostDestination =
            window.location.hostname === "localhost"
              ? `localhost:${window.location.port}`
              : window.location.hostname;

          window.location.href = `http://${hostDestination}`;
        }
        return Promise.reject(error);
      }
    );
    this.id = this.$route.params.id;

    this.getStudent();
  },
  methods: {
    async getStudent() {
      EventBus.$emit("startLoading");
      const studentRes = await axios.get(
        `${this.$api}/admin/detil-siswa?sw_id=${this.id}&&poiuytrewq=poiuytrewq`
      );
      const student = await studentRes.data;

      if (student.STATUS === "SUCCESS") {
        let lampiran_pembayaran = student.PAYLOAD.LAMPIRAN.filter(
          (lampiran) => lampiran.lmp_type === "BUKTI_PEMBAYARAN"
        );

        this.lmp_pembayaran = lampiran_pembayaran[0];
        EventBus.$emit("stopLoading");
      }
    },

    async actionForm(action) {
      const data = {
        sw_id: this.id,
        type: action,
        asdfghjkl: "asdfghjkl",
      };

      EventBus.$emit("startLoading");

      const res = await axios.post(
        `${this.$api}/admin/konfirmasi-tagihan`,
        data
      );

      EventBus.$emit("stopLoading");

      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style scoped>
.card-holder {
  width: 60%;
  margin: 0 auto;
  height: 100vh;
}

.card {
  width: 100%;
}

.preview-holder {
  width: 300px;
  margin: 0 auto;
}

.preview {
  border: 1px solid #374785;
  min-height: 200px;
  max-height: 350px;
  overflow: hidden;
  width: 100%;
}

.preview-image {
  width: 100%;
  height: auto;
}
</style>